// extracted by mini-css-extract-plugin
export default {"chatIconWrapper":"FloatingChatBtn_chatIconWrapper__85jdl"};